import type { ReactNode } from "react";

interface LargeTitleProps {
  title: string;
  eyebrow?: string;
  right?: ReactNode;
  className?: string;
}

export function LargeTitle({ title, eyebrow, right, className = "" }: LargeTitleProps) {
  return (
    <div className={`flex items-end justify-between px-4 pb-2 pt-3 ${className}`}>
      <div>
        {eyebrow && (
          <p className="text-[13px] font-semibold uppercase text-neutral-500">{eyebrow}</p>
        )}
        <h1 className="text-[34px] font-bold leading-tight tracking-tight text-neutral-900">
          {title}
        </h1>
      </div>
      {right}
    </div>
  );
}   